import { memo, type ReactNode, useMemo } from 'react'

import { DataTable } from '@/components/data-table/data-table.organism'
import { cn } from '@/lib/utils'

import { createInvitationActionList, INVITATION_COLUMN_LIST } from './invitation-table.config'
import type { InvitationsListSectionProps, OrganizationInvitation } from './members.interface'

const InvitationsListSectionBase: React.FC<InvitationsListSectionProps> = ({
  invitationList,
  canManageMembers,
  isLoading = false,
  onRevokeInvitation,
  className,
}): ReactNode => {
  const actionList = useMemo(
    () => createInvitationActionList(canManageMembers, onRevokeInvitation),
    [canManageMembers, onRevokeInvitation]
  )

  const getRowId = (row: OrganizationInvitation): string => row.id

  return (
    <div className={cn('invitations-list-section', className)}>
      <DataTable
        data={invitationList}
        columnList={INVITATION_COLUMN_LIST}
        getRowId={getRowId}
        actionList={actionList}
        isLoading={isLoading}
        emptyMessage="No pending invitations"
      />
    </div>
  )
}

export const InvitationsListSection = memo(InvitationsListSectionBase)

InvitationsListSection.displayName = 'InvitationsListSection'
